import { environment } from '../../../../environments/environment';
import { AppService } from './../../services/app.service';
import { Component } from '@angular/core';

@Component({
  selector: 'mobo-menu-wrapper',
  templateUrl: './menu-wrapper.component.html',
  styles: [],
})
export class MenuWrapperComponent {
  public baseUrl = environment.baseUrl;
  public version = environment.siteVersion;
  constructor(public appService: AppService) {}
}
